var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import _ from 'underscore';
import { Map } from 'immutable';
import { myRemoveEntities, myRemoveEntitiesBySport } from './utils';
import { LIVE_INIT, LIVE_UPDATE, LIVE_MATCH_UPDATE, LIVE_MATCH_INIT } from '../../sagas/actions';
import * as PopularActions from '../../actions/popular';
import * as LiveActions from '../../actions/live';
import * as LineActions from '../../actions/lines';
export default function outcomesReducer(outcomes, action) {
    switch (action.type) {
        case PopularActions.CLEAR_POPULAR:
        case LineActions.CLEAR_LINE:
        case LiveActions.CLEAR_LIVE:
        case LiveActions.CLEAR_LIVE_MATCH:
            return Map();
        case LIVE_INIT.SUCCESS:
        case LIVE_MATCH_INIT.SUCCESS:
        case LineActions.SUCCESS_FETCH_LINE_HEADERS:
        case LineActions.SUCCESS_FETCH_SPORT_LINE_HEADERS:
        case LineActions.SUCCESS_FETCH_LEAGUE_LINE_HEADERS:
        case PopularActions.SUCCESS_FETCH_POPULAR_MATCHES:
            return init(new Map(), action.data);
        case LineActions.SUCCESS_FETCH_FULL_LINE:
            var matches = _.map(action.data.events.add, function (m) { return { id: m.id }; });
            outcomes = myRemoveEntities(outcomes, 'matchId', matches);
            return init(outcomes, action.data);
        case LIVE_UPDATE.SUCCESS:
        case LIVE_MATCH_UPDATE.SUCCESS:
            return update(outcomes, action.data);
        default:
            return outcomes;
    }
}
function init(outcomes, data) {
    if (data.outcomes !== undefined) {
        outcomes = addOutcomes(outcomes, data.outcomes.add);
    }
    if (data.blocked_outcomes !== undefined) {
        outcomes = addBlockedOutcomes(outcomes, data.blocked_outcomes.add);
    }
    if (data.rates !== undefined) {
        outcomes = addOutcomeRates(outcomes, data.rates.add);
    }
    return outcomes;
}
function update(outcomes, data) {
    if (data.sports !== undefined && data.sports.remove !== undefined) {
        outcomes = myRemoveEntitiesBySport(outcomes, 'sportId', data.sports.remove);
    }
    if (data.leagues !== undefined && data.leagues.remove !== undefined) {
        outcomes = myRemoveEntities(outcomes, 'leagueId', data.leagues.remove);
    }
    if (data.events !== undefined && data.events.remove !== undefined) {
        outcomes = myRemoveEntities(outcomes, 'matchId', data.events.remove);
    }
    if (data.blocked_outcomes !== undefined) {
        outcomes = removeBlockedOutcomes(outcomes, data.blocked_outcomes.remove);
    }
    if (data.outcomes !== undefined) {
        outcomes = myRemoveEntities(outcomes, 'id', data.outcomes.remove);
        outcomes = addOutcomes(outcomes, data.outcomes.add);
    }
    if (data.blocked_outcomes !== undefined) {
        outcomes = addBlockedOutcomes(outcomes, data.blocked_outcomes.add);
    }
    if (data.rates !== undefined) {
        outcomes = addOutcomeRates(outcomes, data.rates.add);
    }
    return outcomes;
}
function addOutcomes(outcomes, addOutcomes) {
    if (addOutcomes === undefined) {
        return outcomes;
    }
    outcomes = outcomes.withMutations(function (o) {
        for (var i = 0; i < addOutcomes.length; i++) {
            var addedOutcome = addOutcomes[i];
            if (addedOutcome === undefined || addedOutcome.matchId === undefined) {
                throw new Error('Add outcome: parent key not found');
            }
            var plainOutcome = __assign(__assign({}, addedOutcome), { rates: new Map(), isBlocked: false });
            var outcome = new Map(plainOutcome);
            o.set(addedOutcome.id, outcome);
        }
    });
    return outcomes;
}
function addOutcomeRates(outcomes, addRates) {
    if (addRates === undefined) {
        return outcomes;
    }
    for (var i = 0; i < addRates.length; i++) {
        (function (rate) {
            var outcomeId = rate.outcomeId;
            var rateId = rate.id;
            var rateType = rate.type;
            outcomes = outcomes.setIn([outcomeId, 'rates', rateType], rateId);
        })(addRates[i]);
    }
    return outcomes;
}
function addBlockedOutcomes(outcomes, addBlockedOutcomes) {
    if (addBlockedOutcomes === undefined) {
        return outcomes;
    }
    for (var i = 0; i < addBlockedOutcomes.length; i++) {
        var outcomeId = addBlockedOutcomes[i];
        (function (outcomeId) {
            outcomes = outcomes.setIn([outcomeId, 'isBlocked'], true);
        })(outcomeId);
    }
    return outcomes;
}
function removeBlockedOutcomes(outcomes, removeBlockedOutcomes) {
    if (removeBlockedOutcomes === undefined) {
        return outcomes;
    }
    for (var i = 0; i < removeBlockedOutcomes.length; i++) {
        var outcomeId = removeBlockedOutcomes[i];
        (function (outcomeId) {
            outcomes = outcomes.setIn([outcomeId, 'isBlocked'], false);
        })(outcomeId);
    }
    return outcomes;
}



// WEBPACK FOOTER //
// ./src/reducers/entities/outcomesReducer.js